import { mapValues } from 'lodash';
import { ROOT_DB } from 'shared-base';
import { axiosApi } from '../globals';
import { parseMaterials } from '../utils/packs';

export namespace packs {
  export const getAll = () => {
    return axiosApi.run('get', '/carousel/all');
  };

  export const get = async (id: string) => {
    const filename = `EX-${id.padStart(4, '0')}.json`;

    const data = await fetch(`${ROOT_DB}/examples/${filename}`).then((res) => res.json());

    const { models = {} } = data;

    data.models = mapValues(models, (model: any) => {
      return {
        ...model,
        materials: parseMaterials(model.paletteId),
      };
    });

    return {
      isSuccess: true,
      data: data,
    };
  };
}
